/**
 * PRE GMU — Back Office (front público).
 * https://backoffice.demo-gmu.aeioros.com/ — API BO en el mismo host (contexto /).
 */
export const environment = {
  production: false,
  environment: 'gmu',
  API_URL: 'https://backoffice.demo-gmu.aeioros.com/backofficegmu',
  STATIC_BASE_PATH: '',

  optionalModules: [],

  TITLE_HEAD: 'Backoffice - Gerencia Municipal de Urbanismo',
  ICON_TITLE_HEAD: 'assets/emvs/favicon.ico',
  TITLE_REGISTER: 'Gerencia Municipal de Urbanismo',
  TEXT_REGISTER: 'Panel de administración del Ayuntamiento de Córdoba',
  ICON_LATERAL: 'content/images/emvs/logo-panel.png',
  LOGO_HEAD: 'content/images/emvs/logo-head.png',
  TIENE_CALENDARIO: true,
  TIENE_INFO: true,
  TIENE_BUSQUEDA: true,
  FOOTER_INFO_TITLE: null,
  FOOTER_INFO: null,
  COPYRIGHT: null,
};
